const ITEM_RARITY_TRAITS = new Set(['common', 'uncommon', 'rare', 'unique']);

export function splitItemTraits(traits: string | null | undefined): string[] {
  if (!traits) return [];

  const parts: string[] = [];
  let buffer = '';
  let depth = 0;

  for (const char of traits.replace(/\u00a0/g, ' ')) {
    if (char === '(') {
      depth += 1;
      buffer += char;
      continue;
    }
    if (char === ')') {
      depth = Math.max(0, depth - 1);
      buffer += char;
      continue;
    }
    if (char === ',' && depth === 0) {
      const value = buffer.trim();
      if (value) parts.push(value);
      buffer = '';
      continue;
    }
    buffer += char;
  }

  const last = buffer.trim();
  if (last) parts.push(last);

  const merged: string[] = [];
  for (let index = 0; index < parts.length; index += 1) {
    const current = parts[index];
    const next = parts[index + 1];
    const afterNext = parts[index + 2];
    if (/^modular\s+b$/i.test(current) && /^p$/i.test(next || '') && /^or\s+s\)?$/i.test(afterNext || '')) {
      merged.push('Modular (B, P, or S)');
      index += 2;
      continue;
    }
    merged.push(current);
  }

  return merged.filter(trait => !ITEM_RARITY_TRAITS.has(trait.toLocaleLowerCase()));
}

export function normalizeItemTraitKey(value: string | null | undefined): string {
  return String(value || '')
    .replace(/\u00a0/g, ' ')
    .replace(/^PF2E\.TRAITS\./i, '')
    .replace(/\b1d(\d+)\b/gi, 'd$1')
    .replace(/\bft\.?\b/gi, 'ft')
    .replace(/\b(and|or)\b/gi, ' ')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}
